import { render, staticRenderFns } from "./modal-traite-soins-sans-consultation.html?vue&type=template&id=3d9df9d0&scoped=true&external"
import script from "./modal-traite-soins-sans-consultation.js?vue&type=script&lang=js&external"
export * from "./modal-traite-soins-sans-consultation.js?vue&type=script&lang=js&external"
import style0 from "./modal-traite-soins-sans-consultation.scss?vue&type=style&index=0&id=3d9df9d0&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d9df9d0",
  null
  
)

export default component.exports